export default "__VITE_ASSET__da7a1226__"